import { render } from "./StudyMapping.vue?vue&type=template&id=5499101a&scoped=true"
import script from "./StudyMapping.vue?vue&type=script&lang=js"
export * from "./StudyMapping.vue?vue&type=script&lang=js"

import "./StudyMapping.vue?vue&type=style&index=0&id=5499101a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5499101a"]])

export default __exports__